import React from 'react';
import { Trans } from 'react-i18next';
import { notifyTop } from 'UI/Notification/notification';

export const notifyIncompatibleReference = (): void => {
  notifyTop(
    'warning',
    <Trans i18nKey={'common.warning'}>Warning</Trans>,
    <Trans i18nKey={'catalog.search.incompatible_reference_notification.description'}>
      This reference is not compatible with the identified vehicle.
    </Trans>,
  );
};
